import isEqual from 'lodash.isequal';
import cloneDeep from 'lodash.clonedeep';

export function cloneExcept(object: any, propertiesToRemove: string[] = []): any {
	const result: any = {};
	for (const property of Object.getOwnPropertyNames(object)) {
		if (propertiesToRemove.indexOf(property) === -1) {
			result[property] = object[property];
		}
	}
	return result;
}

export function deepEquals(x: any, y: any): boolean {
	return isEqual(x, y);
}

export function deepClone<T>(x: T): T {
	return cloneDeep(x);
}

export interface Identifiable {
	Id: number;
}

// Polyfill para Object.assign sacado de:
// https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Object/assign
if (typeof Object.assign !== 'function') {
	Object.assign = function (target: any, _varArgs: any) { // .length of function is 2
		'use strict';
		if (target == null) { // TypeError if undefined or null
			throw new TypeError('Cannot convert undefined or null to object');
		}

		const to = Object(target);

		for (let index = 1; index < arguments.length; index++) {
			const nextSource = arguments[index];

			if (nextSource != null) { // pasamos si es undefined o null
				for (const nextKey in nextSource) {
					// Evita un error cuando 'hasOwnProperty' ha sido sobrescrito
					if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
		}
		return to;
	};
}

// Polyfill para Object.values/entries adaptado de https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js
if (typeof Object.values !== 'function') {
	Object.values = function values(obj: any) {
		const names = Object.getOwnPropertyNames(obj);
		const values = [];
		for (let i = 0; i < names.length; i++) {
			values.push(obj[names[i]]);
		}
		return values;
	};
}

if (typeof Object.entries !== 'function') {
	Object.entries = function entries(obj: any) {
		const names = Object.getOwnPropertyNames(obj);
		const entries: [string, any][] = [];
		for (let i = 0; i < names.length; i++) {
			entries.push([names[i], obj[names[i]]]);
		}
		return entries;
	};
}
